enum RewardStatus {
    Replaced = 'Replaced', // Replacement has been requested
    Inactive = 'Inactive',
    Processed = 'Processed',
    Mailed = 'Mailed',
    Activated = 'Activated',
    Deactivated = 'Deactivated',
    Expired = 'Expired',
    Undeliverable = 'Undeliverable',
    Validated = 'Validated',
    PendingExport = 'Pending Export',
    Exported = 'Exported',
    Issued = 'Issued',
    UnclaimedProperty = 'Unclaimed Property',
    Cleared = 'Cleared',
}

export default RewardStatus;
